import React from 'react';

import { IonCol, IonGrid, IonRow } from '@ionic/react';

import { Accordion, AccordionGroup } from 'components/Accordion';
import { DescriptionItem } from 'components/DescriptionList';

import './index.css';

const ListSkeleton = () => {
  return (
    <div className={'fr-skeleton'}>
      <AccordionGroup>
        <Accordion>
          <IonGrid>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Period'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Status'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Business partner'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Owner'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Affiliates'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Agreement Type'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Total budget'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Rate of Net Rev.'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Currency'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Monthly budget'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Payment term'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Expense type'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem
                  label={'Traffic restrictions'}
                  type={'skeleton'}
                />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem
                  label={'Invoice requirements'}
                  type={'skeleton'}
                />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'} />
              <IonCol size={'6'}>
                <DescriptionItem label={'Approvers'} type={'skeleton'} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size={'6'}>
                <DescriptionItem label={'Last Updated By'} type={'skeleton'} />
              </IonCol>
              <IonCol size={'6'}>
                <DescriptionItem label={'Created By'} type={'skeleton'} />
              </IonCol>
            </IonRow>
          </IonGrid>
        </Accordion>
        <Accordion title={'Business Partner Contacts'} />
        <Accordion title={'Business Partner Payment Details'} />
        <Accordion title={'Legal Contact Person'} />
      </AccordionGroup>
    </div>
  );
};
export default ListSkeleton;
